import dummyResponse from "./dummyResponse";
import instance from "./instance";
import errorCode from "./../../config/errorCodeAndMsgMap.json";
import { buildErrorResponse } from "../../../components/errors/httpErrorPriority";
export default class Connector {
  searchEmail = (callback) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/apc/partner",
      method: "get",
      params: {},
      headers: headers,
    };
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response?.status === 200) {
            callback(response?.data);
          } else {
            callback({
              isError: true,
              ...(response?.data || {}),
              httpStatus: response?.status,
            });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // const status = e.response && e.response.status;
          // e.response && e.response.data
          //   ? callback({
          //       isError: true,
          //       ...e.response.data,
          //       httpStatus: status,
          //     })
          //   : callback({ isError: true, httpStatus: status });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  updatePartnerInfo = (callback, body, accountId, params = {}) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/apc/partner/" + accountId,
      method: "put",
      params: params,
      data: body,
      headers: headers,
    };
    // callback(dummyResponse.statusCheckProgress);
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response?.status === 200) {
            callback(response?.data);
          } else {
            callback({ isError: true, message: response?.data.message });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // callback({ isError: true });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  fetchContacts = (callback, accountId, params = {}) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/apc/partner/" + accountId + "/contacts",
      method: "get",
      params: params,
      headers: headers,
    };
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response?.status === 200) {
            callback(response?.data);
          } else {
            callback({ isError: true });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // callback({ isError: true });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  createContact = (callback, body, accountId) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/APC/partner/" + accountId + "/contact",
      method: "post",
      data: body,
      headers: headers,
    };
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response?.status === 200) {
            callback(response?.data);
          } else {
            // callback({ isError: true, message: response?.data?.message });
            const error = buildErrorResponse(e);
            callback(error);
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // callback({ isError: true });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  updateContact = (callback, body, accountId, contactId) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/APC/partner/" + accountId + "/contact/" + contactId,
      method: "put",
      data: body,
      headers: headers,
    };
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response?.status === 200) {
            callback(response?.data);
          } else {
            callback({ isError: true, message: response?.data?.message });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // callback({ isError: true });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  fetchReassignContacts = (callback, accountId, params = {}) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/apc/partner/" + accountId + "/reassign",
      method: "get",
      params: params,
      headers: headers,
    };
    //window.setTimeout(callback,1000,JSON.parse(JSON.stringify(dummyResponse.reassignContacts)))
    //callback();
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response?.status === 200) {
            callback(response?.data);
          } else {
            callback({ isError: true });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // callback({ isError: true });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  updateReassignContacts = (callback, body, accountId, params = {}) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/apc/partner/" + accountId + "/reassign",
      method: "put",
      params: params,
      data: body,
      headers: headers,
    };
    //callback({"isError": true,"message":response.data.message});
    // callback(dummyResponse.statusCheckProgress);
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response?.status === 200) {
            callback(response?.data);
          } else {
            if (errorCode.hasOwnProperty(response?.data?.errorCode)) {
              callback({
                isError: true,
                messageCode: errorCode[response?.data?.errorCode],
              });
            } else {
              callback({ isError: true, message: response?.data?.message });
            }
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          if (e?.response?.data?.message) {
            if (errorCode.hasOwnProperty(e?.response?.data?.errorCode)) {
              callback({
                isError: true,
                messageCode: errorCode[e?.response?.data?.errorCode],
              });
            } else {
              callback({ isError: true, message: e?.response?.data?.message });
            }
          } else {
            // callback({ isError: true });
            const error = buildErrorResponse(e);
            callback(error);
          }
        }
      });
  };

  reInviteUser = (callback, accountId, contactId, item) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url:
        "/v1/APC/partner/" + accountId + "/contact/" + contactId + "/reinvite",
      method: "post",
      data: {},
      headers: headers,
    };
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response?.status === 200) {
            callback({ item: item });
          } else {
            callback({ isError: true, message: response?.data?.message });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // callback({ isError: true });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  downloadFile = (callback, accountId, downloadFor) => {
    const headers = {
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
      "x-gw-ims-email": "akshitha+3344@adobetest.com",
    };

    let preparedUrl = "";
    if (accountId && downloadFor && downloadFor === "c2a") {
      preparedUrl = `/api/v1/partner/docgen/apc/agreement_certified_gold/${accountId}`;
    }

    if (accountId && downloadFor && downloadFor === "education") {
      preparedUrl = `/api/v1/partner/docgen/apc/agreement_specialisation/Education/${accountId}`;
    }

    if (accountId && downloadFor && downloadFor === "government") {
      preparedUrl = `/api/v1/partner/docgen/apc/agreement_specialisation/Government/${accountId}`;
    }

    const config = {
      url: preparedUrl,
      method: "GET",
      responseType: "blob",
      headers: headers,
    };
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response?.status === 200) {
            callback(response, downloadFor);
          } else {
            callback(
              { isError: true, message: response?.data?.message },
              downloadFor,
            );
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // callback({ isError: true }, downloadFor);
          const error = buildErrorResponse(e);
          callback({ ...error, downloadFor });
        }
      });
  };
}
